import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const breakpoints = ["xs", "sm", "md", "lg", "xl"];

export default function useResponsiveValue(breakpointConfig) {
  const theme = useTheme();

  // Determine which breakpoint media queries are active
  const activeBreakpoints = {
    xs: useMediaQuery(theme.breakpoints.down("sm")),
    sm: useMediaQuery(theme.breakpoints.between("sm", "md")),
    md: useMediaQuery(theme.breakpoints.between("md", "lg")),
    lg: useMediaQuery(theme.breakpoints.between("lg", "xl")),
    xl: useMediaQuery(theme.breakpoints.up("xl")),
  };

  // Identify the active breakpoint (largest one that matches)
  let activeBreakpoint;
  for (let i = breakpoints.length - 1; i >= 0; i--) {
    if (activeBreakpoints[breakpoints[i]]) {
      activeBreakpoint = breakpoints[i];
      break;
    }
  }

  // If no breakpoint is matched, default to 'xs'
  if (!activeBreakpoint) {
    activeBreakpoint = "xs";
  }

  // Starting at the active breakpoint, "round down" until a value is found
  const activeIndex = breakpoints.indexOf(activeBreakpoint);
  for (let i = activeIndex; i >= 0; i--) {
    const bp = breakpoints[i];
    if (breakpointConfig[bp] !== undefined) {
      return breakpointConfig[bp];
    }
  }

  // If no configuration value is provided at any breakpoint, return undefined.
  return undefined;
}
